import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
  IconButton,
} from "@material-tailwind/react";
import {
  PresentationChartBarIcon,
  ShoppingBagIcon,
  UserCircleIcon,
  Cog6ToothIcon,
  InboxIcon,
  PencilIcon,
} from "@heroicons/react/24/solid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export function DefaultSidebar() {
  const [check, setcheck] = useState("");
  const [logcheck, setlogcheck] = useState("");
  let Token;
  if (localStorage.getItem("Token")) {
    Token = true;
  } else {
    Token = false;
  }
  const islogged = (token) => {
    if (!token) {
      setcheck("d-none");
      setlogcheck("d-block");
    } else {
      setcheck("d-block");
      setlogcheck("d-none");
    }
  };
  useEffect(() => {
    islogged(Token);
  });
  const history = useNavigate();
  const logout = () => {
    try {
      localStorage.removeItem("Token");
      history("/login");
      window.location.reload(false);
    } catch (error) {
      alert("Sorry! there is a problem for logout");
    }
  };
  return (
    <Card className="h-full w-full max-w-[20rem] p-4 shadow-xl shadow-blue-gray-900/5 rounded">
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
      <div className="mb-2 p-4">
        <Typography variant="h5" color="blue-gray">
          <Link to="/">
            <img
              src="https://i.ibb.co/c26z2hZ/image-removebg-preview-11.png"
              alt="image-removebg-preview-11"
              border="0"
              width={"100px"}
            />
          </Link>
        </Typography>
      </div>
      <List>
        <Link to="/home">
          <ListItem className={`${check}`}>
            <div
              className={`d-flex ${check}`}
              style={{ flexDirection: "row !important" }}
            >
              <PencilIcon className="h-5 w-5 mr-4" />
              Tasks
            </div>
          </ListItem>
        </Link>
        <a href="/About">
          <ListItem>
            <ListItemPrefix>
              <ShoppingBagIcon className="h-5 w-5" />
            </ListItemPrefix>
            About Us
          </ListItem>
        </a>
        <ListItem>
          <ListItemPrefix>
            <InboxIcon className="h-5 w-5" />
          </ListItemPrefix>
          Contact us
          
        </ListItem>
        <a href="/profile">
        <ListItem className={`d-flex ${check}`}>
          <div
            className={`d-flex ${check}`}
            style={{ flexDirection: "row !important" }}
          >
            <UserCircleIcon className="h-5 w-5 mr-4" />
            Profile
          </div>
        </ListItem>
        </a>
        <a
          href="https://github.com/sanjeevsingh20/TODO-app.git"
          target="_blank"
        >
          <ListItem>
            <ListItemPrefix>
              {/* <Cog6ToothIcon className="h-5 w-5" /> */}
              <i class="fa-brands fa-github"></i>
            </ListItemPrefix>
            GitHub
          </ListItem>
        </a>
        <IconButton onClick={logout} className={`flex ${check}`}>
          Log Out
        </IconButton>
        <a href="/login">
          <IconButton className={`flex flex-row ${logcheck}`}>
            Log In
          </IconButton>
        </a>
        <a href="/signup">
          <IconButton className={`${logcheck} flex`}>Sign Up</IconButton>
        </a>
      </List>
    </Card>
  );
}
